import { useHoursPerIntensityPoint } from "@/hooks/use-system-config";

interface IntensityHoursHintProps {
  intensity: number;
  className?: string;
}

/**
 * Display-only "≈ N hrs/mo" subtext derived from Intensity × the admin-managed
 * hours-per-Intensity-point constant (`useHoursPerIntensityPoint`, default 40).
 * Purely informational — MUST NEVER feed points math or the Fit Score engine.
 *
 * The underlying endpoint is RM/config-admin gated, so it can 401/403 for other
 * roles. Degrades to rendering nothing while loading or on error — never a
 * spinner, never a misleading "0 hrs".
 */
export function IntensityHoursHint({ intensity, className }: IntensityHoursHintProps) {
  const { data, isSuccess } = useHoursPerIntensityPoint();
  if (!isSuccess || !data) return null;

  const hours = Math.round(intensity * data.value);
  return (
    <span className={`text-[10px] text-muted-foreground ${className ?? ""}`}>≈ {hours} hrs/mo</span>
  );
}
